export default __webpack_public_path__ + "static/media/icon_seccion_activa.6c5383f9.svg";